module.exports = __webpack_public_path__ + "img/625.a7458900.jpg";